<template>
    <div class="agreement-container">
        <div class="agreement">
            <RawAgreement/>
        </div>
        <div class="agreement-group">
            <div class="check flex flex-row justify-center">
                <FormInput :checked="value"
                           type="checkbox" name="agreement" id="agreement"
                           :true-value="1" :false-value="0"
                           @input="s => $emit('input', s)"/>
                <label for="agreement">規約を読んで同意しました</label>
            </div>
            <ErrorText name="agreement" :errors="errors"/>
        </div>
    </div>
</template>

<script>
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";
import RawAgreement from "./RawAgreement";

export default {
    name: "Agreement",
    components: {ErrorText, FormInput, RawAgreement},

    props: {
        value: {
            type: Boolean | Number,
        },
        errors: {
            type: Object | Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
